/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { RangePreset } from 'cio/utils/date-picker';

interface SegmentMembershipDatePickerAllTimePresetArgs {
  preset: RangePreset;
}

export default class SegmentMembershipDatePickerAllTimePreset extends Component<SegmentMembershipDatePickerAllTimePresetArgs> {
  get range() {
    return this.args.preset.getRange();
  }
}
